export default __webpack_public_path__ + "static/media/pc.52f268ad.png";